import type { RootState } from '@/app/store';

export const selectBalloonStatus = (s: RootState) => s.balloon.status;
export const selectBalloonMultiplier = (s: RootState) => s.balloon.multiplier;
export const selectBalloonPauseRemainingMs = (s: RootState) => s.balloon.pauseRemainingMs;
export const selectBalloonBetAmount = (s: RootState) => s.balloon.betAmount;
export const selectBalloonCurrency = (s: RootState) => s.balloon.currency;
export const selectBalloonServerSeedHash = (s: RootState) => s.balloon.serverSeedHash;
export const selectBalloonResult = (s: RootState) => s.balloon.result;
export const selectBalloonLoading = (s: RootState) => s.balloon.loading;
